import { useState } from '@/runtime';
export type ThemeName = 'light' | 'dark';
const STORAGE_KEY = 'sst-theme';

export function currentTheme(): ThemeName {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return 'light';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(name: ThemeName) {
  document.documentElement.dataset.theme = name;
  try { localStorage.setItem(STORAGE_KEY, name); } catch { /* приватный режим: тема живёт до перезагрузки */ }
}

export function useTheme() {
  const theme = useState<ThemeName>('theme', () => 'light');
  function sync() { theme.value = document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light'; }
  function toggle() { applyTheme(theme.value === 'dark' ? 'light' : 'dark'); sync(); }
  return { theme, sync, toggle };
}
